import _ from "lodash";
export const getLabelValue = ({ item, t }) => {
  const { name, title } = item;

  return name || title || t("common:untitled");
};

export const getMbRegionLocalizedKey = ({ tagValue }) => {
  return _.replace(tagValue, / /g, "_");
};

export const getTagValues = (tags, t, fn) => {
  return _.map(tags, tag => {
    let tagKey = tag.key;
    let tagValue = tag.value;

    if (tagKey === "REGION") {
      tagKey = t("common:region");
      const localizedKeyTag = getMbRegionLocalizedKey({ tagValue });
      tagValue = t(`common:r_${localizedKeyTag}`);
    } else if (tag.key === "MAPLEBEAR_USER") {
      tagKey = t("common:usertype");
      tagValue = _.capitalize(tagValue);
    }

    const label = fn ? fn(tag) : `${tagKey} - ${tagValue}`;
    return {
      label,
      value: tag.id,
      disabled: _.get(tag, "disabled", false),
    };
  });
};

export const getLabelValueForMultiFilterLabelButton = ({
  options = [],
  selectedOptions = [],
  t,
  allText,
  noneText,
  haveNestedOptions = false,
}) => {
  const optionsLength = haveNestedOptions
    ? _.sumBy(options, option => (option.options ? option.options.length : 1))
    : options.length;

  const selectedOptionsLength = selectedOptions.length;

  // used for FilterLabelButton component from Design Library
  if (optionsLength === 0 || selectedOptionsLength === 0) {
    return noneText ?? t("common:none");
  } else if (optionsLength === selectedOptionsLength) {
    return allText ?? t("common:all");
  } else {
    return selectedOptions;
  }
};
